import { history } from '_helpers';

export function handleError(error) {

    if (typeof error === "object") {
       history.push('/admin/error');
       return ('EPT Services Down');
    }
    return error;
}